'use client';
import cn from 'classnames';
import Image from 'next/image';
import Link from 'next/link';
import PriveeKeyholeWhite from 'public/img/icon/keyhole-white.png';

import './PriveeAddOn.style.scss';

import Text from '@/components/common/Text/Text';
import { useFlags } from '@/components/hook/flags';
import { FLAG_KEYS } from '@/const/flags';

type PriveeAddOnProps = {
  className?: string;
  href?: string;
  children?: React.ReactNode;
};

function PriveeAddOn(props: PriveeAddOnProps) {
  const { className = '', href, children } = props;
  const { value: flagValues } = useFlags();
  const isPriveeOn = flagValues[FLAG_KEYS.PRIVEE];

  if (!isPriveeOn) return null;

  const content = (
    <>
      <Image
        className='PriveeAddOn__keyhole'
        src={PriveeKeyholeWhite}
        alt='Réservé Keyhole in white'
        width={892}
        height={1814}
      />
      <p className='PriveeAddOn__title'>Réservé Add-On</p>
      <Text
        variant='text-m'
        className='PriveeAddOn__description'
      >
        R&eacute;serv&eacute; is our invite-only tier, available exclusively as
        an add-on to an active Vivrelle membership.
      </Text>
      {children}
    </>
  );

  if (href) {
    return (
      <Link
        href={href}
        className={cn('PriveeAddOn', 'PriveeAddOn--link', className)}
      >
        {content}
      </Link>
    );
  }

  return <div className={cn('PriveeAddOn', className)}>{content}</div>;
}

export default PriveeAddOn;
